"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { ArrowRight } from "lucide-react";
export default function ArtSpaceHero() {
  return <section data-section-id="103770" id="質感空間主視覺-premium-living-hero" className="dark bg-background text-foreground relative h-screen min-h-[600px] w-full overflow-hidden flex flex-col items-start justify-center">
      <style dangerouslySetInnerHTML={{
      __html: `
          @import url('https://fonts.googleapis.com/css2?family=Source+Sans+3:wght@200..900&display=swap');
          
          .font-source-sans {
            font-family: 'Source Sans 3', sans-serif;
          }

          @keyframes slowPan {
            0% { transform: scale(1.05) translate(0, 0); }
            50% { transform: scale(1.1) translate(-1%, 1%); }
            100% { transform: scale(1.05) translate(0, 0); }
          }
          
          @keyframes scrollLine {
            0% { transform: translateY(-100%); opacity: 0; }
            20% { opacity: 1; }
            80% { opacity: 1; }
            100% { transform: translateY(100%); opacity: 0; }
          }
          
          .animate-slow-pan {
            animation: slowPan 40s ease-in-out infinite;
          }
          
          .animate-scroll-line {
            animation: scrollLine 2.5s cubic-bezier(0.645, 0.045, 0.355, 1) infinite;
          }
        `
    }} />

      {/* 背景影像層 */}
      <div className="absolute inset-0 z-0">
        <video autoPlay loop muted playsInline fetchPriority="high" /* 提升 LCP 優先權 */ className="w-full h-full object-cover opacity-90 animate-slow-pan" poster="https://hent.services/wp-content/uploads/2026/05/light_livingroom_bg-scaled.webp">
          {/* 建議將影片來源也換成您的 domain 以提升加載速度 */}
       
        </video>
        <div className="absolute inset-0 bg-gradient-to-r from-black/10 via-black/5 to-transparent" />
      </div>

      {/* 內容文字層 */}
      <div className="relative z-10 flex flex-col items-start text-left px-10 md:px-24 lg:px-40 max-w-6xl w-full font-source-sans">
        
        <span className="text-xs md:text-[15px] tracking-[0.5em] font-acumin mb-5 
          animate-in fade-in slide-in-from-bottom-6 duration-1000 fill-mode-both">
          Hent's Flooring
        </span>

        <h1 className="text-white leading-[1.1] mb-8 drop-shadow-2xl 
          animate-in fade-in slide-in-from-bottom-10 duration-1000 delay-300 fill-mode-both
          text-4xl md:text-6xl lg:text-7xl tracking-tight">
          <span className="font-normal font-antiqua-bold">Makes Your</span> <br />
          <span className="font-normal font-antiqua-bold">Home Warmer</span>
        </h1>

        <p className="tracking-wide leading-relaxed mb-12 
          animate-in fade-in slide-in-from-bottom-6 duration-1000 delay-500 fill-mode-both
          text-sm md:text-lg max-w-xl font-hk-light">
          讓自然與工藝，成就家的溫度
        </p>
        
        <div className="animate-in fade-in slide-in-from-bottom-4 duration-1000 delay-700 fill-mode-both">
          <button onClick={() => {
          const element = document.getElementById("產品展示牆");
          if (element) {
            element.scrollIntoView({
              behavior: "smooth",
              block: "start"
            });
          }
        }} className="rounded-none border border-white/30 bg-white/5 backdrop-blur-sm text-white px-10 py-5 text-xs hover:bg-white hover:text-black transition-all duration-500 tracking-[0.4em] font-bold flex items-center group">
            熱銷產品 <ArrowRight className="ml-3 size-4 transition-transform group-hover:translate-x-1" />
          </button>
        </div>
      </div>

      {/* 下向捲動 SCROLL */}
      <div className="absolute bottom-10 left-1/2 -translate-x-1/2 z-20 flex flex-col items-center gap-4 !p-0">
        <span className="text-[10px] uppercase tracking-[0.3em] text-white/60 font-medium font-source-sans">
          向下捲動 SCROLL
        </span>
        <div className="w-[1px] h-16 bg-white/10 relative overflow-hidden">
          <div className="absolute top-0 left-0 w-full h-full bg-[#ffffff] animate-scroll-line" />
        </div>
      </div>
    </section>;
}